/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { interviewBookingMessageStore } from '../../axios/interviewBookingMessageStore'
import type {
	InterviewBookingMessageStoreError,
	InterviewBookingMessageStoreRequest,
	InterviewBookingMessageStoreResponse,
} from '../../types/InterviewBookingMessageStore'

export const interviewBookingMessageStoreMutationKey = () => [{ url: '/interview-scheduling/tokens/messages' }] as const

export type InterviewBookingMessageStoreMutationKey = ReturnType<typeof interviewBookingMessageStoreMutationKey>

export type InterviewBookingMessageStoreVariables = {
	data: InterviewBookingMessageStoreRequest
}

/** @see backend/nexus/modules/InterviewScheduling/Http/Controllers/InterviewBookingMessageController.php InterviewBookingMessageController::store */
export function useInterviewBookingMessageStore<TContext = unknown>(
	options?: UseMutationOptions<
		InterviewBookingMessageStoreResponse,
		AxiosError<InterviewBookingMessageStoreError>,
		InterviewBookingMessageStoreVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: interviewBookingMessageStoreMutationKey(),
		mutationFn: ({ data }: InterviewBookingMessageStoreVariables) =>
			interviewBookingMessageStore(data, config).then(res => res.data),
		...options,
	})
}
